import { useEffect } from 'react';
import { desktopBridge, platformState } from './client-platform';

const forms = new Set<string>();
export function setDesktopFormDirty(id: string, dirty: boolean) {
  if (dirty) forms.add(id);
  else forms.delete(id);
  void desktopBridge()
    ?.setDirty(forms.size > 0)
    .catch(() => undefined);
}
export function useDesktopDirty(id: string, dirty: boolean) {
  useEffect(() => {
    setDesktopFormDirty(id, dirty);
    return () => setDesktopFormDirty(id, false);
  }, [id, dirty]);
}
export function desktopDraftSuffix() {
  const current = platformState();
  return current ? `:${current.windowId}` : '';
}
